/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chartperiodweek2Inputs */

const en_chartperiodweek2 = /** @type {(inputs: Chartperiodweek2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week`)
};

const de_chartperiodweek2 = /** @type {(inputs: Chartperiodweek2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woche`)
};

/**
* | output |
* | --- |
* | "Week" |
*
* @param {Chartperiodweek2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const chartperiodweek2 = /** @type {((inputs?: Chartperiodweek2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chartperiodweek2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chartperiodweek2(inputs)
	return de_chartperiodweek2(inputs)
});
export { chartperiodweek2 as "chartPeriodWeek" }